import React, { useEffect, useMemo, useState } from 'react'
import withSlideUpModal from '../../utils/hoc/withSlideUpModalComponent'
import { ApplicationData, Requirements as CampaignRequirements } from '../../types/sponsorships/campaigns'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux-stores/store'
import IgConnectBenefits from '../igConnect/IgConnectBenefits'
import { Link, useLocation } from 'react-router-dom'
import { INIT_IG_AUTH_ROUTE } from '../../constants/constants'
import { setIntendedPath } from '../../redux-stores/slices/layoutSlice'
import { AppDispatch } from '../../redux-stores/slices/authSlice'
import Select from 'react-select'
import { SocialAccount } from '../../types/influencer/influencerTypes'
const CampaignApplyConfirmationModal: React.FC<{ application: ApplicationData, apply: (languageId?: string) => void, status: string, campaignRequirements?: CampaignRequirements, socialAccount: SocialAccount }> = ({ application, apply, status, campaignRequirements, socialAccount }) => {
    const dispatch: AppDispatch = useDispatch();
    const location = useLocation();
    const connectionRequired = useSelector((state: RootState) => state.influencer.connectionRequired);
    const [selectedLanguage, setSelectedLanguage] = useState<{ label: string, value: string } | null>(null);
    const languages = useSelector((state: RootState) => state.auth.master?.language_list);

    const matchedCriteria = useMemo(() => {
        return Object.values(application.match?.requirement_matches ?? {}).filter((req) => req.match)
    }, [application]);

    const notMatchedCriteria = useMemo(() => {
        return Object.values(application.match?.requirement_matches ?? {}).filter((req) => !req.match)
    }, [application]);

    useEffect(() => {
        setSelectedLanguage(null);
    }, [application])

    const eligibleLanguages = useMemo(() => {
        let campaignLanguages: { label: string, value: string }[] = [];
        if (campaignRequirements && Array.isArray(campaignRequirements?.languages)) {
            for (let languageId of campaignRequirements.languages) {
                if (languages && languages[languageId]) {
                    campaignLanguages.push({ label: languages[languageId], value: languageId });
                }
            }
        }
        return campaignLanguages;
    }, [campaignRequirements, languages])


    const applyCampaign = () => {
        if (eligibleLanguages.length > 0) {
            if (!selectedLanguage) return;
            apply(selectedLanguage.value)
        } else {
            apply()
        }
    }

    return (
        <div className='campaign-apply-confirmation'>
            <div className="d-flex flex-column gap-075">
            </div>

            <div className="campaign-apply-ig-connect-benefit-actions">
                <div>
                    <div className="form-group gap-2 d-flex flex-column mb-3">
                        <label htmlFor="">Applying using</label>
                        <div className="d-flex align-items-center gap-2">
                            <img src={(socialAccount.profile_picture_url ?? '').split("=")[0]} alt="" className='rounded-sm' width={60} height={60} />
                            <span className='text-dark'>{socialAccount.handle}</span>
                        </div>
                    </div>
                </div>
                {
                    eligibleLanguages.length > 0 &&
                    <div className="profile-input my-2 mt-2 mb-3">
                        <label htmlFor="">Please select language which you will use</label>
                        <Select isClearable classNamePrefix={'influns-app'} className="profile-input-form-control-wrapper" placeholder='Select Language*' menuPlacement='top' options={eligibleLanguages} onChange={(selected: any) => setSelectedLanguage(selected)} />
                    </div>
                }
                <div className={`campaign-apply-disclaimer mb-2`}>
                    <span className="fw-bold">Disclaimer: </span>
                    <span>Application selection is decided by brand.</span>
                </div>
                <button onClick={applyCampaign} disabled={status === 'PENDING' || (eligibleLanguages.length > 0 && !selectedLanguage)} className="new-ui-btn">{status === 'PENDING' ? 'Applying...' : 'Apply'}</button>
            </div>

        </div>
    )
}

export default withSlideUpModal(CampaignApplyConfirmationModal)